// marker for instance ID in paths
export const INSTANCE_ID_MARKER = ':iid';

// base path for per-instance views in the UI
export const PATH_PREFIX_INSTANCE = `/inst/${INSTANCE_ID_MARKER}`;

// base path for per-instance resource views
export const PATH_PREFIX_RESOURCES = `${PATH_PREFIX_INSTANCE}/resources`;

// base path for the app inspector views
export const PATH_PREFIX_APPINSPECTOR = `${PATH_PREFIX_INSTANCE}/appinspector`;
